export default __webpack_public_path__ + "static/banner_connpass_20230831-c853099f8e81c2eadbcfea0413840dd3.png";